module.exports = __webpack_public_path__ + "img/han_jie_gong_zuo_zhan1.b290ce3a.png";